import { Card } from "@/components/ui/card";

import { ActivityLogDetailDialog } from "./activity-log-detail-dialog";
import { ActivityLogFilters } from "./activity-log-filters";
import { ActivityLogTable } from "./activity-log-table";
import { useActivityLogs } from "./use-activity-logs";

export function ActivityLogList() {
  const {
    q,
    setQ,
    entityName,
    setEntityName,
    activity,
    setActivity,
    dateFrom,
    dateTo,
    setDateRange,
    workspaceId,
    setWorkspaceId,
    page,
    setPage,
    resetFilters,
    items,
    pagination,
    isLoading,
    selectedLog,
    detailOpen,
    openDetail,
    closeDetail,
  } = useActivityLogs();

  const total = pagination?.total ?? 0;
  const lastPage = pagination?.lastPage ?? 1;

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">
            Riwayat Aktivitas & Perubahan Data
          </h1>
          <p className="text-sm text-muted-foreground">
            Lacak siapa yang mengubah data, kapan, dan lihat perbedaan nilai
            sebelum serta sesudah diubah.
          </p>
        </div>
      </div>

      <Card>
        <ActivityLogFilters
          q={q}
          setQ={setQ}
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateRange={setDateRange}
          entityName={entityName}
          setEntityName={setEntityName}
          activity={activity}
          setActivity={setActivity}
          workspaceId={workspaceId}
          setWorkspaceId={setWorkspaceId}
          resetFilters={resetFilters}
        />

        <ActivityLogTable
          items={items}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          total={total}
          lastPage={lastPage}
          openDetail={openDetail}
        />
      </Card>

      <ActivityLogDetailDialog
        open={detailOpen}
        onOpenChange={(open) => !open && closeDetail()}
        log={selectedLog}
      />
    </div>
  );
}

export default ActivityLogList;
